<template>
    <div class="container honor-content">
        <el-row :gutter="32">
            <el-col
                :span="6"
                v-for="(item, index) in list"
                :key="item.title + index"
                :xs="{ span: 24 }"
                :sm="{ span: 8 }"
            >
                <el-card :body-style="{ padding: '0px' }">
                    <el-image
                        style="width: 100%; height: 275px"
                        :src="item.url"
                        fit="contain"
                        :preview-src-list="[item.url]"
                    >
                    </el-image>
                    <div class="card-title">
                        {{ item.title }}
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    props: ['list'],
}
</script>
<style scoped lang="less">
.honor-content {
    padding: 40px 0 8px;
}
.card-title {
    line-height: 60px;
    background-color: #999;
    text-align: center;
    color: #fff;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 0 16px;
    &:hover {
        background-color: #004797;
        color: #fff;
    }
}
.el-col {
    margin-bottom: 32px;
}
/deep/ .el-image {
    .el-image__inner:hover {
        transform: scale(1.1);
        transition: all 0.3s ease-in;
    }
}
</style>
